import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import ConfirmationDialog from '../common/Modal/ConfirmationDialog';
import RadioButton from '../common/RadioGroup/RadioButton';
import "./GuidedExperienceWizard.css";

import { WizardInteractionEventPayload } from '../../types/GA4Events/WizardEventParams';
import trackWizardEvent, { createWizardEventPayload } from '../../utils/GA4EventHelpers/trackWizardEvent';

interface ConfirmImportWizardProps {
    setConfirmedImport: (value: boolean) => void;
    setSelectDelete: (value: boolean) => void;
    confirmedImport: undefined | boolean;
}

export default function ConfirmImportWizard(props: ConfirmImportWizardProps): JSX.Element {
    const { t } = useTranslation("guided_wizard");
    const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false)

    const handleSelection = (value: boolean) => {
        const wizardEventPayload: WizardInteractionEventPayload = createWizardEventPayload({
            wizard_type: "commercial",
            wizard_interaction_type: "start",
            wizard_import_decision: value === true ? "accepted" : "declined",
            wizard_step: 1
        })
        trackWizardEvent(wizardEventPayload)

        props.setConfirmedImport(value)
        props.setSelectDelete(!value)
    }
    return (<div>
        <div className='wizard-radio-cell wizard-question'>
            <fieldset>
                <legend>{t("confirm-import-wizard.confirm-import-question")}</legend>
                <RadioButton name="confirm-import-question" id="confirm-import-question-yes" text={t("yes")} textPosition='right' value="true" currentValue={props.confirmedImport ?? ""}
                    onChange={() => handleSelection(true)} testid='wizard-import-yes' />
                <RadioButton name="confirm-import-question" id="confirm-import-question-no" text={t("no")} textPosition='right' value="false" currentValue={props.confirmedImport ?? ""}
                    onChange={() => setShowConfirmDeleteModal(true)} testid='wizard-import-no' />
            </fieldset>
        </div>
        {
            showConfirmDeleteModal && <ConfirmationDialog
                onCancel={() => setShowConfirmDeleteModal(false)}
                onConfirm={() => handleSelection(false)}
                headerClass="no-border" buttonGroupClass="justify-content-center no-border"
                cancelTestId='wizard-cancel-delete-all'
                confirmTestId='wizard-confirm-delete-all'
            >
                <Trans t={t}
                    i18nKey="confirm-remove-previous-units"
                    components={{ p: <p /> }}
                />
            </ConfirmationDialog>
        }
    </div>)
}